// Generated by purs version 0.15.7
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var logShow = /* #__PURE__ */ Effect_Class_Console.logShow(Effect_Class.monadEffectEffect)(Data_Show.showString);
var F = /* #__PURE__ */ (function () {
    function F(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    F.create = function (value0) {
        return function (value1) {
            return new F(value0, value1);
        };
    };
    return F;
})();
var Pure = /* #__PURE__ */ (function () {
    function Pure(value0) {
        this.value0 = value0;
    };
    Pure.create = function (value0) {
        return new Pure(value0);
    };
    return Pure;
})();
var Impure = /* #__PURE__ */ (function () {
    function Impure(value0) {
        this.value0 = value0;
    };
    Impure.create = function (value0) {
        return new Impure(value0);
    };
    return Impure;
})();
var unsafeRun = function ($copy_dictShow) {
    return function ($copy_v) {
        return function ($copy_v1) {
            var $tco_var_dictShow = $copy_dictShow;
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(dictShow, v, v1) {
                if (v1 instanceof Pure) {
                    $tco_done = true;
                    return pure(v1.value0);
                };
                if (v1 instanceof Impure) {
                    var v2 = v(v1.value0.value0);
                    if (v2 instanceof Data_Either.Left) {
                        $tco_done = true;
                        return new Data_Either.Left(Data_Function["const"]("ERROR")(Effect_Unsafe.unsafePerformEffect(logShow(v2.value0))));
                    };
                    if (v2 instanceof Data_Either.Right) {
                        $tco_var_dictShow = dictShow;
                        $tco_var_v = v;
                        $copy_v1 = v1.value0.value1(v2.value0);
                        return;
                    };
                    throw new Error("Failed pattern match at Freer (line 48, column 32 - line 50, column 33): " + [ v2.constructor.name ]);
                };
                throw new Error("Failed pattern match at Freer (line 45, column 1 - line 45, column 92): " + [ v.constructor.name, v1.constructor.name ]);
            };
            while (!$tco_done) {
                $tco_result = $tco_loop($tco_var_dictShow, $tco_var_v, $copy_v1);
            };
            return $tco_result;
        };
    };
};
var showF = function (dictShow) {
    var show = Data_Show.show(dictShow);
    return {
        show: function (v) {
            return "F(" + (show(v.value0) + ")");
        }
    };
};
var showEff = function (dictShow) {
    var show = Data_Show.show(showF(dictShow));
    return function (dictShow1) {
        var show1 = Data_Show.show(dictShow1);
        return {
            show: function (v) {
                if (v instanceof Pure) {
                    return "Pure(" + (show1(v.value0) + ")");
                };
                if (v instanceof Impure) {
                    return "Impure(" + (show(v.value0) + ")");
                };
                throw new Error("Failed pattern match at Freer (line 20, column 1 - line 22, column 49): " + [ v.constructor.name ]);
            }
        };
    };
};
var functorF = {
    map: function (f) {
        return function (v) {
            return new F(v.value0, function ($59) {
                return f(v.value1($59));
            });
        };
    }
};
var map = /* #__PURE__ */ Data_Functor.map(functorF);
var effFunctor = {
    map: function (v) {
        return function (v1) {
            if (v1 instanceof Pure) {
                return new Pure(v(v1.value0));
            };
            if (v1 instanceof Impure) {
                return new Impure(map(Data_Functor.map(effFunctor)(v))(v1.value0));
            };
            throw new Error("Failed pattern match at Freer (line 24, column 1 - line 26, column 46): " + [ v.constructor.name, v1.constructor.name ]);
        };
    }
};
var effApply = {
    apply: function (v) {
        return function (v1) {
            if (v instanceof Pure && v1 instanceof Pure) {
                return new Pure(v.value0(v1.value0));
            };
            if (v instanceof Impure) {
                return new Impure(map(Data_Function.flip(Control_Apply.apply(effApply))(v1))(v.value0));
            };
            if (v1 instanceof Impure) {
                return new Impure(map(Control_Apply.apply(effApply)(v))(v1.value0));
            };
            throw new Error("Failed pattern match at Freer (line 28, column 1 - line 31, column 50): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Functor0: function () {
        return effFunctor;
    }
};
var effBind = {
    bind: function (v) {
        return function (v1) {
            if (v instanceof Pure) {
                return v1(v.value0);
            };
            if (v instanceof Impure) {
                return new Impure(map(Data_Function.flip(Control_Bind.bind(effBind))(v1))(v.value0));
            };
            throw new Error("Failed pattern match at Freer (line 33, column 1 - line 35, column 53): " + [ v.constructor.name, v1.constructor.name ]);
        };
    },
    Apply0: function () {
        return effApply;
    }
};
var effApplicative = {
    pure: function (a) {
        return new Pure(a);
    },
    Apply0: function () {
        return effApply;
    }
};
var effMonad = {
    Applicative0: function () {
        return effApplicative;
    },
    Bind1: function () {
        return effBind;
    }
};
var eff = function (e) {
    return new Impure(new F(e, Pure.create));
};
export {
    F,
    Pure,
    Impure,
    eff,
    unsafeRun,
    showF,
    functorF,
    showEff,
    effFunctor,
    effApply,
    effBind,
    effApplicative,
    effMonad
};
